export default __webpack_public_path__ + "static/media/mtsLogo.252a1460.png";